module.exports = "<div id=\"mainImage\" [ngStyle]=\"{'background-image': 'url(' + displayUrl + ')', 'width': width}\"></div>\n"